/*
 * Basic file with global javascript.
 * Files imported here will be available on every page.
 */

import '../../utils/swiper';

import Alpine from 'alpinejs';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/zoom';

import '~/styles/main.css'; // tailwind
import '~/styles/account.css'; // subscription account nav

/** Global Scripts */
import { navStore, navDesktopComponent, navMobileComponent } from '../snippets/navigation';
import xOnShopify from '~js/alpine-plugins/x-on-shopify';
import drawerV2 from '../snippets/drawer-v2';
import responsiveImageV2 from '~js/utils/responsive-image-v2';
import { stickyHeader } from '../sections/header';
import { algoliaHandler, searchComponent } from '../snippets/algolia-search';
import { rebuyCartHandler, rebuyCartState } from '../snippets/rebuy-cart';
import { evaluateScreenSize } from '~js/utils/helpers';
import { observeAttentiveOverlay } from '~js/utils/dom';

/** Collection Scripts */
import productCard from '../snippets/product-card.js';
import productsBrowser from '../sections/products-browser';
import productsBrowserFacetsWrapper from '../snippets/products-browser-facets-wrapper.js';
import productsBrowserFacet from '../snippets/products-browser-facet.js';
import productsBrowserFacetSlider from '../snippets/products-browser-facet-slider.js';
import productsBrowserSort from '../snippets/products-browser-sort';

/** Cart Scripts */
import { cartStore, cartComponent } from '../snippets/cart';
import lineItemComponent from '../snippets/line-item.js';
import recommendedProducts from '../snippets/recommended-products';
import { productData } from '../snippets/product-variant-selection.js';
import { quickBuyModal } from '../snippets/quick-buy-modal';

/** Product Detail Page Scripts */
import heroProduct from '../sections/hero-product.js';
import { desktopStepsSlider } from '../sections/content-with-steps.js';
import { productGridCarousel } from '../sections/product-grid-carousel.js';
import { blogGridCarousel } from '../sections/blog-grid-carousel.js';
import heroProductGallery from '../snippets/hero-product-gallery';
import heroProductGalleryModal from '../snippets/hero-product-gallery-modal';
import heroProductAdd from '../snippets/hero-product-add';
import heroProductInfo from '../snippets/hero-product-info';
import heroProductAccordion from '../snippets/hero-product-accordion.js';

/** Components */
import productExplorerInit from '../sections/product-explorer';
import { testimonialsCarousel } from '../sections/testimonials-carousel';
import { herbFinder } from '../sections/where-is-my-herbId';
import { changePlaceholderText } from '../sections/landing-page-newsletter';
import { initTestimonialCarousel } from '../sections/reviews-carousel';
import { initImageCarousel } from '../sections/image-carousel';

import { initThumbnailSwiper } from '../sections/thumbnail-content';
import { initIngredientList } from '../sections/ingredient-list';
import { initProductGrid } from '../sections/product-grid';
import { initFeaturedProduct } from '../sections/featureProduct';

/** Blogs & Articles */
import blogsSection from '../sections/blog';

// create an event listener here
document.addEventListener('cart-updated', ({ detail }) => {
  const cartCountSelector = document.querySelector('.notification-badge');
  cartCountSelector.innerHTML = detail.cart.item_count;
});

/** Global Components */

Alpine.data('navDesktop', navDesktopComponent);
Alpine.data('navMobile', navMobileComponent);
Alpine.data('drawerV2', drawerV2);
Alpine.data('responsiveImageV2', responsiveImageV2);
Alpine.data('searchComponent', searchComponent);

/** Collection Components */
Alpine.data('productsBrowser', productsBrowser);
Alpine.data('productsBrowserFacet', productsBrowserFacet);
Alpine.data('productsBrowserFacetSlider', productsBrowserFacetSlider);
Alpine.data('productsBrowserFacetsWrapper', productsBrowserFacetsWrapper);
Alpine.data('productCard', productCard);
Alpine.data('productsBrowserSort', productsBrowserSort);

/** Load Cart Components */
Alpine.data('cartComponent', cartComponent);
Alpine.data('productData', productData);
Alpine.data('lineItemComponent', lineItemComponent);
Alpine.data('recommendedProducts', recommendedProducts);

/**Load Product Detail Page Components */
Alpine.data('heroProduct', heroProduct);
Alpine.data('heroProductGallery', heroProductGallery);
Alpine.data('heroProductGalleryModal', heroProductGalleryModal);
Alpine.data('heroProductAdd', heroProductAdd);
Alpine.data('heroProductInfo', heroProductInfo);
Alpine.data('heroProductAccordion', heroProductAccordion);

/** Account Nav  */

import AccountNav from '../snippets/account-menu.js';
document.addEventListener('DOMContentLoaded', () => {
  AccountNav.setup();
});

/** Blogs & Articles  */
Alpine.data('blogsSection', blogsSection);

/** Extra Components */
Alpine.data('productExplorer', productExplorerInit);

const navStoreInstance = navStore();
Alpine.store('nav', navStoreInstance);

const rebuyCartStateInstance = rebuyCartState();
Alpine.store('rebuyCart', rebuyCartStateInstance);

const quickBuyModalInstance = quickBuyModal();
Alpine.store('quickBuyModal', quickBuyModalInstance);

const cartStoreInstance = cartStore();
Alpine.store('cart', cartStoreInstance);
window.cartStore = cartStoreInstance;

Alpine.plugin(xOnShopify);

evaluateScreenSize();
stickyHeader();
algoliaHandler().init();
rebuyCartHandler().init();
desktopStepsSlider();
productGridCarousel();
blogGridCarousel();
testimonialsCarousel();
herbFinder();
initThumbnailSwiper();
initIngredientList();
initProductGrid();
changePlaceholderText();
initTestimonialCarousel();
initImageCarousel();
initFeaturedProduct();

/*
  Observe the Email sign-up popup coming from the Attentive app 
  to make it appear behind the Rebuy Cart.
*/
observeAttentiveOverlay();

window.Alpine = Alpine;
Alpine.start();

// // BUGHERD
if (window.location.hostname !== '127.0.0.1' && !window.Shopify.designMode && window.Shopify.theme.role !== 'main') {
  const script = document.createElement('script');
  script.src = 'https://www.bugherd.com/sidebarv2.js?apikey=czwfalkp21nfn9k6j07x4q';
  document.head.append(script);
}
